export const BRPConflictProps = [
  'noWrap',
  'labelPosition',
  'fullOrInpage',
  'active',
  'vMedia',
  'hMedia',
  'inFocus',
  'multiLine',
  'invalid',
  'register',
  'registerDescriber',
  'fieldSize',
  'inputState',
  'show',
  'maxLines',
  'multiline',
  'lineCount',
  'underline',
  'srOnly',
  'alignLeft',
  'alignCenter',
  'alignRight',
  'alignJustify',
  'displayBlock',
  'gutterBottom',
  'paragraph',
  'sortType',
  'sortSize',
  'mode',
  'describers',
  'cursor',
  'direction',
  'icon',
  'labelSize',
  'display',
  'width',
  'height',
  'size',
  'color',
  'fontSize',
  'fontWeight',
  'overflow',
  'opacity'  
];

export const BRPStyledComponentKeepProps = [
  'sx'
];